import Component from './component';
import { ComponentType } from '../types/app-types';

type Components = Record<ComponentType, Component[]>;

class App {
  private static _components: Partial<Components> = {};

  public static get components() {
    return this._components;
  }

  public static getComponentsOfType<T extends Component = Component>(type: ComponentType): T[] {
    return (this._components[type] || []) as T[];
  }

  public static addComponent(component: Component) {
    if (this._components[component.type]) {
      this._components[component.type].push(component);
    } else {
      this._components[component.type] = [component];
    }
  }

  public static removeComponent({ type, key }: Component) {
    this._components[type] = this.getComponentsOfType(type).filter(
      component => component.key !== key,
    );
  }
}

export default App;
